<h2 mat-dialog-title>Error details</h2>
<mat-dialog-content class="log-error-dialog-content">
	<div *ngIf="data.orderno || data.created_at" class="mb-2 text-muted small">
		<span *ngIf="data.orderno">Order: {{ data.orderno }}</span>
		<span *ngIf="data.created_at">{{ data.orderno ? ' · ' : '' }}{{ data.created_at | date:'short' }}</span>
	</div>
	<div *ngIf="data.message" class="log-error-message-summary mb-2">{{ data.message }}</div>
	<pre class="log-error-pre mb-0">{{ data.error_details }}</pre>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
